<template>
  <div>
    <div v-if="loadingFornecedoresProdutos">
      <px-circular-loading/>
    </div>
    <template v-if="!loadingFornecedoresProdutos">
      <px-lista-fornecedor-header :values="value"
                                  :initial-selection-count="initialSelectionCount"
                                  @change="onChangeFilter"
                                  @resetfornecedor="emitReset"
                                  @remove="onRemoveFornecedor"/>
      <px-lista-fornecedor-list :fornecedores="fornecedores"
                                :options-list="optionsList"
                                :loading="loading"
                                v-model="localValue"
                                :on-change-options="onChangeOptions"/>
    </template>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import FornecedorService from '@/api/fornecedor-service';
import paginationMixin from '@/mixins/pagination-mixin';
import { hasAnyLetter, formatCnpj } from '@/utils/regex-utils';
import PxListaFornecedorList from './PxListaFornecedorList.vue';
import PxListaFornecedorHeader from './PxListaFornecedorHeader.vue';

export default {
  mixins: [paginationMixin],
  props: {
    value: Array,
    produtos: Array,
  },
  data() {
    return {
      initialSelectionCount: 0,
      filters: {
        searchText: null,
        estados: [],
        municipios: [],
      },
      loading: false,
      loadingFornecedoresProdutos: false,
      fornecedores: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'nome',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    emitReset() {
      this.$emit('resetfornecedor');
    },
    buildStringFilter() {
      const cnpjQuery = !hasAnyLetter(this.filters.searchText) ? ` or cnpj like "${formatCnpj(this.filters.searchText)}%"` : '';
      const stringfilters = [];
      if (this.filters.searchText) {
        const searchTextFilter = `(nome like '%${this.filters.searchText.toLowerCase()}%'${cnpjQuery})`;
        stringfilters.push(searchTextFilter);
      }
      if (this.filters.municipios && this.filters.municipios.length) {
        const municipiosFilter = this.filters.municipios.map(municipio => `(municipio = ${municipio.id})`);
        stringfilters.push(`(${municipiosFilter.join(' or ')})`);
      }
      if (this.filters.estados && this.filters.estados.length) {
        const estadosFilter = this.filters.estados.map(estado => `(estado = ${estado.id})`);
        stringfilters.push(`(${estadosFilter.join(' or ')})`);
      }
      return stringfilters.join(' and ');
    },
    onChangeFilter(filters) {
      this.filters = filters;
      this.listOptions.filter = this.buildStringFilter();
      this.resetPage();
      this.getFornecedores();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getFornecedores();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getFornecedores() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      FornecedorService.getFornecedoresScore({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
        codigoInterno: this.getFilterCodigoInterno(),
      })
        .then(({ data }) => {
          this.fornecedores = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getFilterCodigoInterno() {
      if (this.filters.searchText) {
        return this.filters.searchText.trim();
      }
      return null;
    },
    getFilterProdutos() {
      if (isEmpty(this.produtos)) {
        return null;
      }
      const ids = this.produtos.filter(produto => !!produto.produto)
        .map(produto => produto.produto.id);
      return ids ? `${ids.join(',')}` : null;
    },
    getFornecedoresProdutos() {
      this.loadingFornecedoresProdutos = true;
      FornecedorService.getFornecedoresScore({
        limit: 20,
        offset: 0,
        produtosGestao: this.getFilterProdutos(),
      })
        .then(({ data }) => {
          if (data.content && data.content.length) {
            this.initialSelectionCount = data.content.length;
            this.localValue = data.content;
          }
        })
        .finally(() => {
          this.loadingFornecedoresProdutos = false;
          this.optionsList = this.pageToOptions(this.listOptions);
        });
    },
    onRemoveFornecedor(fornecedor) {
      this.localValue = this.localValue.filter(f => f.id !== fornecedor.id);
    },
  },
  created() {
    // se já tiver fornecedores selecionados, não fazemos a busca novamente
    if (this.localValue && this.localValue.length) {
      this.optionsList = this.pageToOptions(this.listOptions);
      return;
    }
    this.getFornecedoresProdutos();
  },
  components: {
    PxListaFornecedorList,
    PxListaFornecedorHeader,
  },
};
</script>
